import { connect } from 'react-redux';
import storage from 'app/services/storage';
import moviesModule from 'app/store/movies';
import cinemaModule from 'app/store/cinemas';
import searchModule from 'app/store/search';
import MovieDetails from './MovieDetails.component';

const {
  requestMovie,
  requestDateList,
  requestSessions,
  moviesFilter,
  setSessions,
  setMovie,
  setDateList,
  moviesFilterSuccess,
  setNewSessions,
  eventsWebFetchGet,
  setUpcomingMovies,
  setDaysSessions
} = moviesModule.actions;

const { requestCinemas } = cinemaModule.actions

const { searchRequest } = searchModule.actions;

const mapDispatchToProps = {
  getMovie: requestMovie,
  getDateList: requestDateList,
  getSessions: requestSessions,
  setMovie,
  setSessions,
  setCinemas: requestCinemas,
  setNewSessions,
  setDateList,
  moviesFilterSuccess,
  findMovie: searchRequest,
  findMoviefilter: moviesFilter,
  eventsWebFetch: eventsWebFetchGet,
  setUpcomingMovies,
  setDaysSessions
};

const mapStateToProps = ({ movies, user, layout, cinemas }) => (
  {
    films: movies.films,
    dates: movies.datesDetails,
    movieDetails: movies.movieDetails,
    movieFilterDetails: movies.movieFilterDetails,
    sessions: movies.sessions,
    daysSessions: movies.daysSessions,
    isLoggedIn: !!user.user,
    savedLocation: storage.getLocation(),
    savedCinema: storage.getCinema(),
    eventWeb: movies.eventWeb,

    locations: layout.locations,
    cinemas: cinemas.cinemas,

    saveLocation: location => {
      storage.setLocation(location);
    },
  });

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(MovieDetails);
